var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"scale__wrap"},[_c('div',{staticClass:"scale"},[_c('div',{staticClass:"scale-active",class:_vm.hasClass})]),_c('div',{staticClass:"scale__percent"},[_vm._v(" "+_vm._s(_vm.percent))])])
}
var staticRenderFns = []

export { render, staticRenderFns }